import React, { useState, useEffect, useContext, useRef, useLayoutEffect, useMemo } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { UncontrolledTooltip, Badge, Spinner } from "reactstrap";
import { getPermission } from "utils/Utils";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Row,
  Col,
  PaginationComponent,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  Button,
  RSelect,
} from "../../../components/Component";
import { Link } from "react-router-dom";
import { TicketContext } from "./TicketContext";
import {
  serviceGetAllTickets,
  serviceGetTicketSummary,
  serviceGetTickets,
  serviceGetTicketsByField,
  serviceGetTicketsByQuery,
  serviceGetTicketsById,
  serviceGetTicketByIds,
} from "services/tickets";
import { serviceGetChatById } from "services/chats";
import { useCookies } from "react-cookie";
import { getDepartments, getDepartmentsAll } from "services/departments";
import getTextColor from "components/custom/getTextColor";
import moment from "moment";
import SimpleBar from "simplebar-react";
import { serviceGetCampaigns } from "services/campaign";
import { getTagsForTickets } from "services/tags";
import { MessagesContext } from "contexts/messagesContext";
import { useLocation } from "react-router-dom";
import { utilNumberPhoneConvention } from "../chat/utils/ChatUtils";
import { getTagCategories } from "services/tagCategories";
import * as XLSX from "xlsx";

const BOT_ID = "3ef9f486-ddad-46ed-b568-f7b32a62262f";

const statusOption = [
  { value: "ALL", label: "ALL" },
  { value: "RESOLVED", label: "RESOLVED" },
  { value: "PENDING", label: "PENDING" },
  { value: "UNOPENED", label: "UNOPENED" },
  { value: "OPENED", label: "OPENED" },
];

const ratingOption = [
  { value: "ALL", label: "ALL" },
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];

// ticket.channel -> badge label
export const CHANNEL_LABEL = { whatsapp: "WhatsApp", instagram: "Instagram", livechat: "Live Chat" };

const channelOption = [
  { value: "ALL", label: "ALL" },
  ...Object.entries(CHANNEL_LABEL).map(([value, label]) => ({ value, label })),
];

export const CampaignBadge = (campaign, item) => {
  switch (campaign) {
    case "Instagram":
      return <div className="badge campaign-badge__instagram">Instagram</div>;
    case "Live Chat":
      return <div className="badge campaign-badge__livechat">Live Chat</div>;
    case "Facebook":
      return <div className="badge campaign-badge__facebook">Facebook</div>;
    case "Youtube":
      return <div className="badge campaign-badge__youtube">Youtube</div>;
    default:
      return <div className="badge campaign-badge__whatsapp">{campaign}</div>;
  }
};

const Ticket = () => {
  const nonFixedRef = useRef([]);
  nonFixedRef.current = [];
  const [nonFixedHeight, setNonFixedHeight] = useState([]);
  const [cookies] = useCookies(["user"]);
  const { contextData } = useContext(TicketContext);
  const { messagesValue, salesUpdate, ticketUpdate } = useContext(MessagesContext);
  const [currentItems, setCurrentItems] = contextData;
  const [campaignOption, setCampaignOption] = useState([{ value: "ALL", label: "ALL" }]);
  const [sm, updateSm] = useState(false);
  const [, setonSearch] = useState(false);
  const [, setOnSearchText] = useState("");
  const [isLoadingDownload, setIsLoadingDownload] = useState(false);
  const [summaryData, setSummaryData] = useState({
    opened: 0,
    pending: 0,
    resolved: 0,
    unopened: 0,
  });
  const [, setDepartmentData] = useState([]);
  const [tagsData, setTagsData] = useState([]);
  const [sortKeyword, setSortKeyword] = useState("");
  const [activeSearch, setActiveSearch] = useState("");
  const roleFunctions = getPermission()["tickets"]?.access || [];
  const [metaData, setMetaData] = useState({
    itemCount: 0,
    page: 0,
    take: 0,
    pageCount: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  const { search } = useLocation();
  const ticketStatusParam = new URLSearchParams(search).get("ticketStatus");
  const [orderBy, setOrderBy] = useState("DESC");
  const [businessOption, setbusinessOption] = useState([]);
  const [leadSourceOption, setLeadSourceOption] = useState([]);
  const [prospectOption, setProspectOption] = useState([]);
  const [isSorting, setIsSorting] = useState(false);

  const [queryId] = useState("");
  const [queryName, setQueryName] = useState("");
  const [queryContact, setQueryContact] = useState("");
  const [queryPhone, setQueryPhone] = useState("");
  const [showPlus, setShowPlus] = useState(true);
  const [queryLeadSource, setQueryLeadSource] = useState("");
  const [queryProspect, setQueryProspect] = useState("");
  const [queryCampaign, setQueryCampaign] = useState("");
  const [queryStatus, setQueryStatus] = useState(ticketStatusParam ? ticketStatusParam : "");
  const [queryRating, setQueryRating] = useState("");
  const [queryPic, setQueryPic] = useState("");
  const [queryBusiness, setQueryBusiness] = useState("");
  const [queryChannel, setQueryChannel] = useState("");
  const [triggerPersistentRefresh, setTriggerPersistentRefresh] = useState(1);

  const [fieldName, setFieldName] = useState("");
  const [fieldId] = useState("");
  const [fieldContact, setFieldContact] = useState("");
  const [fieldPhone, setFieldPhone] = useState("");
  const [fieldLeadSource, setFieldLeadSource] = useState("");
  const [fieldProspect, setFieldProspect] = useState("");
  const [fieldCampaign, setFieldCampaign] = useState("");
  const [fieldStatus, setFieldStatus] = useState("");
  const [fieldRating, setFieldRating] = useState("");
  const [fieldPic, setFieldPic] = useState("");
  const [queryText, setQueryText] = useState("");
  const [fieldText, setFieldText] = useState("");
  const [chatbotTicket, setChatbotTicket] = useState([]);
  const [newMessages] = messagesValue;
  const [newSales] = salesUpdate;
  const [newTicket] = ticketUpdate;

  const [campaignPage, setCampaignPage] = useState(0);
  const [runGetCampaign, setRunGetCmapaign] = useState(0);
  const [leadSourceId, setLeadSourceId] = useState("");
  const [statusProspectId, setStatusProspectId] = useState("");

  const refresthDepartmentData = async () => {
    const responseGetUser = await getTagsForTickets(cookies.SIDikey);
    const responseGetDepartments = await getDepartments(
      cookies.SIDikey,
      "",
      cookies.departmentIds,
      cookies.id,
      roleFunctions,
    );
    setDepartmentData(responseGetDepartments.data.data);
    setTagsData(responseGetUser.data.data);
  };

  const getCategories = async () => {
    const response = await getTagCategories(cookies.SIDikey);

    try {
      const leadSource = response.data.data.find((item) => item.name === "Lead Source");
      const leadProspect = response.data.data.find((item) => item.name === "Status Prospect");
      setLeadSourceId(leadSource.id);
      setStatusProspectId(leadProspect.id);
    } catch (error) {
      //console.log(error);
    }
  };

  useEffect(() => {
    getCategories();
    refresthDepartmentData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (newMessages.length > 0) {
      const lastMessage = newMessages.at(-1);
      const matchDataWithMessage = currentItems.findIndex((ticket) => ticket.id === lastMessage.ticketId);

      //console.log('lastmessage ticket', lastMessage);

      if (lastMessage.type === "INTERACTIVE" && lastMessage.content) {
        //console.log('ticket interactive', lastMessage);
        if (
          lastMessage.content.includes("list_reply") &&
          lastMessage.content.includes("rating") &&
          matchDataWithMessage >= 0
        ) {
          updateRatingByTicket(lastMessage, matchDataWithMessage, currentItems);
          //console.log('ticket rating', lastMessage);
          return;
        }
      }

      //jika pesan dari bot dan tidak memiliki akses view_chatbot
      if (!roleFunctions.includes("View_Chatbot") && lastMessage?.chat?.userId === BOT_ID) {
        return;
      } else if (
        roleFunctions.includes("Access_Own_Dept") &&
        !cookies.departmentIds.includes(lastMessage?.chat?.channel?.departmentId)
      ) {
        return;
      }

      if (roleFunctions.includes("View_Chatbot") && lastMessage?.chat?.userId === BOT_ID) {
        setTriggerPersistentRefresh(triggerPersistentRefresh + 1);
        return;
      }

      const updateData = [...currentItems];
      if (lastMessage.type === "tag-update") {
        // update tag based on chat
        if (matchDataWithMessage >= 0 && currentItems[matchDataWithMessage].status !== "RESOLVED") {
          updateData[matchDataWithMessage].tags = lastMessage.tags;
          setCurrentItems([...updateData]);
        }
        return;
      } else if (lastMessage.type === "PURCHASE" && lastMessage.text.includes("ASSIGN")) {
        if (matchDataWithMessage >= 0 && lastMessage?.chat) {
          updateData[matchDataWithMessage].user = lastMessage?.chat?.user;
          if (lastMessage?.chat?.tickets?.length > 0) {
            updateData[matchDataWithMessage].status = lastMessage?.chat?.tickets[0]?.status;
          }
          setCurrentItems([...updateData]);
        }
      } else if (lastMessage.type === "tag-update-resolve") {
        if (matchDataWithMessage >= 0) {
          updateData[matchDataWithMessage].status = "RESOLVED";
          setCurrentItems([...updateData]);
        }
        return;
      } else if (lastMessage.type === "status-update") {
        if (matchDataWithMessage >= 0) {
          const targetItem = updateData[matchDataWithMessage];

          if (lastMessage.status) {
            // Update the status
            targetItem.status = lastMessage.status;
            // Merge chat information
            targetItem.chat = {
              ...targetItem.chat,
              ...lastMessage.chat,
            };
            setCurrentItems(updateData);
          }
        }
        return;
      } else if (lastMessage.type === "TEXT") {
        setTriggerPersistentRefresh(triggerPersistentRefresh + 1);
        return;
      }

      if (matchDataWithMessage >= 0) {
        // update user and status from chat page
        const updateData = [...currentItems];
        // const messageContent = lastMessage.content ? JSON.parse(lastMessage.content) : "";
        if (lastMessage?.chat?.user?.role?.name === "SALES") {
          updateData[matchDataWithMessage].status = lastMessage?.chat.status;
        } else if (lastMessage?.chat?.user?.role?.name === "CS") {
          updateData[matchDataWithMessage].status = lastMessage?.chat.csStatus;
        }
        updateData[matchDataWithMessage].user = lastMessage?.chat?.user;
      }

      //jika ada perpindahan sales
      if (roleFunctions.includes("Access_Own") && lastMessage?.chat?.userId !== cookies.id) {
        if (matchDataWithMessage >= 0) {
          const updateData = [...currentItems];
          updateData.splice(matchDataWithMessage, 1);
          setCurrentItems(updateData);
        } else return;
      } else if (roleFunctions.includes("Access_Own") && lastMessage?.chat?.userId === cookies.id) {
        const matchDataWithChatbotTicket = chatbotTicket.find((item) => item === lastMessage?.chat.id);
        if (matchDataWithChatbotTicket || lastMessage.type === "PURCHASE") {
          // add ticket after chatbot to sales
          getNewTicket(lastMessage?.chat.id);
        } else {
          // refreshTickets(metaData?.page ?? 1);
          setTriggerPersistentRefresh(triggerPersistentRefresh + 1);
        }
      } else if (
        roleFunctions.includes("Access_Own_Dept") &&
        cookies.departmentIds.includes(lastMessage?.chat?.channel?.departmentId)
      ) {
        const matchDataWithChatbotTicket = chatbotTicket.find((item) => item === lastMessage?.chat.id);
        if (matchDataWithChatbotTicket || lastMessage.type === "PURCHASE") {
          // add ticket after chatbot to sales
          getNewTicket(lastMessage?.chat.id);
        } else {
          //console.log('add ticket after chatbot to sales', lastMessage)
          // refreshTickets(metaData?.page ?? 1);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newMessages]);

  useEffect(() => {
    if (!salesUpdate[0]) return;
    if (currentItems.length <= 0) {
      setTriggerPersistentRefresh(triggerPersistentRefresh + 1);
      return;
    }
    salesUpdate.map((salesArr) => {
      if (!salesArr) return false;
      ticketUpdateBySales(salesArr);

      return false;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newSales]);

  useEffect(() => {
    if (currentItems.length <= 0) return false;
    ticketUpdateNew();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newTicket]);

  const updateRatingByTicket = async (lastMessage, matchDataWithMessage, data) => {
    const resGetTicketData = await serviceGetTicketsById(cookies.SIDikey, lastMessage.ticketId);
    if (resGetTicketData) {
      const updateData = [...currentItems];
      updateData[matchDataWithMessage].rating = resGetTicketData.data.data[0].rating;
      setCurrentItems(updateData);
    }
  };

  const ticketUpdateNew = async () => {
    const newData = [];
    await Promise.all(
      ticketUpdate.map(async (ticket) => {
        if (!ticket) return false;
        if (roleFunctions.includes("Access_All_Dept")) {
          const getNewData = await getNewTicketById(ticket.id);
          if (getNewData) {
            newData.push(getNewData);
          }
        }
        if (roleFunctions.includes("Access_Own")) {
          // filter ticket berdasarkan department
          if (ticket.salesId === cookies.id) {
            const getNewData = await getNewTicketById(ticket.id);
            if (getNewData) {
              newData.push(getNewData);
            }
          }
          if (ticket.salesId === BOT_ID) {
            // add new ticket later to sales
            setChatbotTicket([ticket.chatId, ...chatbotTicket]);
          }
        }
        if (roleFunctions.includes("Access_Own_Dept") && cookies.departmentIds.includes(ticket.departmentId)) {
          if (roleFunctions.includes("View_Chatbot")) {
            const getNewData = await getNewTicketById(ticket.id);
            if (getNewData) {
              newData.push(getNewData);
            }
          } else {
            if (ticket.salesId === BOT_ID) {
              setChatbotTicket([ticket.chatId, ...chatbotTicket]);
            } else {
              const getNewData = await getNewTicketById(ticket.id);
              if (getNewData) {
                newData.push(getNewData);
              }
            }
          }
        }
      }),
    );
    setCurrentItems([...newData, ...currentItems]);
  };

  const ticketUpdateBySales = async (salesArr) => {
    if (!salesArr || salesArr.length === 0) return;

    const MAX_TICKET_LIMIT = 15;
    const ticketData = [...currentItems];
    const newData = [];

    if (ticketData.length <= 0) {
      setTriggerPersistentRefresh(triggerPersistentRefresh + 1);
      return;
    }

    const processedSales = salesArr.filter((sales) => sales && sales.ticket && sales.ticket.length > 0);

    for (const sales of processedSales) {
      const totalCurrentTickets = newData.length + ticketData.length;
      if (totalCurrentTickets >= MAX_TICKET_LIMIT) break;

      const matchDataIndex = ticketData.findIndex((ticket) => ticket.id === sales.ticket[0].id);

      // Update user for matching ticket
      if (matchDataIndex >= 0) {
        ticketData[matchDataIndex].user = sales.chat.user;
      }

      // Handle sales based on role and user
      if (roleFunctions.includes("Access_Own")) {
        const isOwnSales = sales.chat.user.id === cookies.id;

        if (isOwnSales && matchDataIndex < 0) {
          // New sales for this user
          let newTicket = { ...sales.ticket[0], chat: sales.chat, user: sales.chat.user };
          newData.push(newTicket);
        } else if (!isOwnSales && matchDataIndex >= 0) {
          // Remove ticket if not owned by current user
          ticketData.splice(matchDataIndex, 1);
        }
      }
    }

    const updatedTickets = [...newData, ...ticketData].slice(0, MAX_TICKET_LIMIT);
    setCurrentItems(updatedTickets);

    if (updatedTickets.length >= MAX_TICKET_LIMIT) {
      setTriggerPersistentRefresh(triggerPersistentRefresh + 1);
    }
  };

  const getNewTicket = async (chatId) => {
    const resGetTicketId = await serviceGetChatById(cookies.SIDikey, chatId);
    if (resGetTicketId.status === 200) {
      const resGetTicketData = await serviceGetTicketsById(cookies.SIDikey, resGetTicketId.data.lastMessage.ticketId);
      if (resGetTicketData.status === 200) {
        const findTicketOnData = currentItems.findIndex((item) => item.id === resGetTicketData.data.data[0].id);
        if (findTicketOnData < 0) {
          setCurrentItems([resGetTicketData.data.data[0], ...currentItems]);
        }
      }
    }
  };

  const getNewTicketById = async (ticketId, ticketData = currentItems) => {
    const resGetTicketData = await serviceGetTicketsById(cookies.SIDikey, ticketId);
    if (resGetTicketData.status === 200) {
      const findTicketOnData = ticketData.findIndex((item) => item.id === resGetTicketData.data.data[0].id);
      if (findTicketOnData < 0) {
        return resGetTicketData.data.data[0];
      }
      return false;
    }
    return false;
  };

  useEffect(() => {
    setLeadSourceOption([
      { value: "ALL", label: "ALL" },
      ...tagsData
        .filter((item) => item?.tagCategory?.name === "Lead Source")
        .map((item) => ({
          label: item?.name || "Unknown",
          value: item?.id || "unknown",
          category: item?.tagCategory ?? {},
        })),
    ]);

    setProspectOption([
      { value: "ALL", label: "ALL" },
      ...tagsData
        .filter((item) => item?.tagCategory?.name === "Status Prospect")
        .map((item) => ({
          label: item?.name || "Unknown",
          value: item?.id || "unknown",
          category: item?.tagCategory ?? {},
        })),
    ]);
  }, [tagsData]);

  useLayoutEffect(() => {
    if (nonFixedRef.current) {
      const tempHeight = [];
      nonFixedRef.current.forEach((ref) => {
        const height = ref.offsetHeight;
        tempHeight.push(height);
      });
      setNonFixedHeight(tempHeight);
    }
  }, [currentItems]);
  const refreshTickets = async (pageNumber) => {
    const resp = await serviceGetTickets(
      cookies.SIDikey,
      roleFunctions,
      cookies.departmentIds,
      cookies.id,
      pageNumber,
      queryChannel,
    );
    //console.log('get tickets', resp)
    setMetaData(resp.data.meta);
    if (new RegExp(/20+/).test(resp.status)) {
      const ticketData = resp.data.data;
      setCurrentItems(ticketData);
    } else {
    }
  };

  const roleFunctionsCampaign = getPermission()["campaigns"]?.access || [];
  const refreshCampaign = async (page = 0, campaignOption) => {
    const resp = await serviceGetCampaigns(
      cookies.SIDikey,
      roleFunctionsCampaign,
      cookies.departmentIds,
      cookies.id,
      page + 1,
    );
    if (new RegExp(/20+/).test(resp.status)) {
      const campaignData = resp.data.data;
      if (campaignOption && campaignOption.length > 0) {
        setCampaignOption([
          ...campaignOption,
          ...campaignData.map((item) => ({ value: item.id, label: item.link.name })),
        ]);
      } else {
        setCampaignOption([...campaignData.map((item) => ({ value: item.id, label: item.link.name }))]);
      }
      if (resp.data.meta.hasNextPage) {
        setCampaignPage(page + 1);
      } else {
        setCampaignPage(-1);
      }
    } else {
      //console.log(resp);
    }
  };

  const handleCampaignSelectScroll = () => {
    setRunGetCmapaign((getC) => getC + 1);
  };

  useEffect(() => {
    if (campaignPage >= 0) {
      refreshCampaign(campaignPage, campaignOption);
    }
  }, [runGetCampaign]); // eslint-disable-line react-hooks/exhaustive-deps

  const refreshBusinessOpt = async () => {
    const resp = await getDepartmentsAll(cookies.SIDikey, ["Access_All_Dept"], "DESC", "department.createdAt");
    if (new RegExp(/20+/).test(resp.status)) {
      let departmentOptData = resp.data;
      if (!roleFunctions.includes("Access_All_Dept")) {
        departmentOptData = departmentOptData.filter((df) => cookies.departmentIds.some((dp) => df.id === dp));
      }
      setbusinessOption([
        { value: "ALL", label: "ALL" },
        ...departmentOptData?.map((item) => ({ label: item?.name, value: item.id })),
      ]);
    } else {
      //console.log(resp);
    }
  };

  const refreshTicketsByQuery = async (query, pageNumber, field, departmentId) => {
    const sort = {
      field: sortKeyword,
      order: orderBy,
      queryRating,
      queryStatus,
      queryBusiness: queryBusiness,
    };

    const resp = await serviceGetTicketsByQuery(
      cookies.SIDikey,
      cookies.id,
      cookies.departmentIds,
      query.replace(/,+/g, ","),
      roleFunctions,
      pageNumber,
      field,
      sort,
      queryStatus,
      queryRating,
      statusProspectId,
      leadSourceId,
      queryChannel,
    );
    if (new RegExp(/20+/).test(resp.status)) {
      const ticketData = resp.data.data;
      const ticketIDs = ticketData.map((itm) => itm.id);
      if (field.includes("tags.name")) {
        const getTicketIDs = await serviceGetTicketByIds({
          token: cookies.SIDikey,
          ticketIDs,
        });
        if (new RegExp(/20+/).test(getTicketIDs.status)) {
          ticketData.forEach((itm) => {
            const tagsByTicket = getTicketIDs.data.data.find((ticket) => ticket.id === itm.id);
            itm.tags = tagsByTicket.tags;
          });
        }
      }
      setCurrentItems(ticketData);
      setMetaData(resp.data.meta);
    } else {
      //console.log(resp);
    }
  };

  const refreshTicketByField = async (field, pageNumber, order) => {
    const queryFilter = {
      queryText,
      fieldText,
      queryRating,
      queryStatus,
    };
    const resp = await serviceGetTicketsByField(
      cookies.SIDikey,
      cookies.id,
      cookies.departmentId,
      field,
      roleFunctions,
      pageNumber,
      order,
      queryFilter,
      queryStatus,
      queryRating,
      queryChannel,
    );
    if (new RegExp(/20+/).test(resp.status)) {
      const ticketData = resp.data.data;
      setCurrentItems(ticketData);
      setMetaData(resp.data.meta);
    } else {
      //console.log(resp);
    }
  };

  const refreshTicketSummary = async () => {
    const resp = await serviceGetTicketSummary(cookies.SIDikey, cookies.departmentId, cookies.id, roleFunctions);
    const data = resp?.data;
    setSummaryData({
      opened: data?.OPENED,
      unopened: data?.TOTAL - data?.RESOLVED - data?.PENDING - data?.OPENED - (data?.SOLVED || 0),
      resolved: data?.RESOLVED,
      pending: data?.PENDING,
    });
  };

  useMemo(() => {
    if (ticketStatusParam) {
      refreshTicketsByQuery(queryText, 1, fieldText, "");
    } else {
      refreshTickets(1);
    }

    refreshCampaign();
    refreshBusinessOpt();
    refreshTicketSummary();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onSelectChangeBusiness = (e) => {
    if (e.value !== "ALL") {
      setQueryBusiness(e.value);
      refreshTicketsByQuery(queryText, 1, fieldText, e.value);
    } else {
      setQueryBusiness("");
      setTriggerPersistentRefresh(triggerPersistentRefresh + 1);
      // refreshTickets(1, "");
    }
  };
  const onSelectChangeCampaign = (e) => {
    if (e.value !== "ALL") {
      setQueryCampaign("," + e.value);
      setFieldCampaign(",campaign.id");
    } else {
      setQueryCampaign("");
      setFieldCampaign("");
      setTriggerPersistentRefresh(triggerPersistentRefresh + 1);
      // refreshTickets(1);
    }
  };
  const onSelectChangeLeadSource = (e) => {
    if (e.value !== "ALL") {
      setQueryLeadSource("," + e.value);
      setFieldLeadSource(",tags.lead");
    } else {
      setQueryLeadSource("");
      setFieldLeadSource("");
      setTriggerPersistentRefresh(triggerPersistentRefresh + 1);
      // refreshTickets(1);
    }
  };
  const onSelectProspect = (e) => {
    if (e.value !== "ALL") {
      setQueryProspect("," + e.value);
      setFieldProspect(",tags.prospect");
    } else {
      setQueryProspect("");
      setFieldProspect("");
      setTriggerPersistentRefresh(triggerPersistentRefresh + 1);
      // refreshTickets(1);
    }
  };

  const onSelectStatus = (e) => {
    if (e.value !== "ALL") {
      setQueryStatus(e.label);
      setFieldStatus(",ticket.status");
    } else {
      setQueryStatus("");
      setFieldStatus("");
      setTriggerPersistentRefresh(triggerPersistentRefresh + 1);
      // refreshTickets(1);
    }
  };

  const onSelectChannel = (e) => setQueryChannel(e.value === "ALL" ? "" : e.value);

  const onSelectRating = (e) => {
    if (e.value !== "ALL") {
      setQueryRating(e.label);
      setFieldRating(",ticket.rating");
    } else {
      setQueryRating("");
      setFieldRating("");
      setTriggerPersistentRefresh(triggerPersistentRefresh + 1);
      // refreshTickets(1);
    }
  };

  const onSortClicked = (id, order) => {
    setOrderBy(order);
    refreshTicketByField(id, 1, order);
    setIsSorting(true);
    setSortKeyword(id);
  };

  const paginate = (pageNumber) => {
    const savedFilter = JSON.parse(localStorage.getItem("currentFilter"));
    if (isSorting) {
      if (
        (savedFilter.queryText !== "" && savedFilter.fieldText !== "") ||
        savedFilter.queryRating !== "" ||
        savedFilter.queryStatus !== "" ||
        savedFilter.queryBusiness !== ""
      ) {
        return refreshTicketsByQuery(
          savedFilter.queryText,
          pageNumber,
          savedFilter.fieldText,
          savedFilter.queryBusiness,
          savedFilter.orderBy,
          savedFilter.queryStatus,
          savedFilter.queryRating,
        );
      } else {
        return refreshTicketByField(sortKeyword, pageNumber, orderBy);
      }
    } else {
      if (
        (savedFilter.queryText !== "" && savedFilter.fieldText !== "") ||
        savedFilter.queryRating !== "" ||
        savedFilter.queryStatus !== "" ||
        savedFilter.queryBusiness !== ""
      ) {
        return refreshTicketsByQuery(
          savedFilter.queryText,
          pageNumber,
          savedFilter.fieldText,
          savedFilter.queryBusiness,
          savedFilter.orderBy,
          savedFilter.queryStatus,
          savedFilter.queryRating,
        );
      } else {
        return refreshTickets(pageNumber, queryBusiness);
      }
    }

    // if (isSorting) {
    //     return refreshTicketByField(sortKeyword, pageNumber, orderBy);
    // } else if ((isSorting) && (savedFilter.queryText !== "" && savedFilter.fieldText !== "") ||
    // savedFilter.queryRating !== "" || savedFilter.queryStatus !== "" || savedFilter.queryBusiness !== "") {
    //     return refreshTicketsByQuery(savedFilter.queryText,
    //       pageNumber,
    //       savedFilter.fieldText,
    //       savedFilter.queryBusiness,
    //       orderBy,
    //       savedFilter.queryStatus,
    //       savedFilter.queryRating);
    // } else {
    //     return refreshTickets(pageNumber, queryBusiness);
    // }
  };

  const addToRefs = (el) => {
    if (el && !nonFixedRef.current.includes(el)) {
      nonFixedRef.current.push(el);
    }
  };

  const handleDownload = async () => {
    setIsLoadingDownload(true);
    try {
      // Step 1: Get data
      //console.log("Starting download process");
      const resp = await serviceGetAllTickets(cookies.SIDikey);
      //console.log("API response received:", resp ? "Data received" : "No data");

      // Step 2: Transform data
      try {
        const tempData = resp.map((item) => {
          const products = item?.chat?.contact?.metadata;
          return {
            "Ticket ID": item?.id || "",
            "Ticket Name": item?.name || "",
            "Customer Name": item?.chat?.contact?.name || "",
            "Number Telephone": item?.chat?.customerPhone || "",
            Bussiness: item?.department?.name || "",
            "Lead Source":
              item?.tags
                ?.filter((tag) => tag?.tagCategory?.name === "Lead Source") // Filter by tagCategory
                .map((tag) => tag.name)
                .join(",") || "",
            Prospect:
              item?.tags
                ?.filter((tag) => tag?.tagCategory?.name === "Status Prospect") // Filter by tagCategory
                .map((tag) => tag.name)
                .join(",") || "",
            Campaign: item?.campaign?.name || "",
            Channel: CHANNEL_LABEL[item?.channel] || item?.channel || "",
            Status: item?.status || "",
            PIC: item?.user?.firstName ? item?.user?.firstName + " " + item?.user?.lastName : "",
            Rating: item?.rating || "",
            "Rate At": item?.ratedAt || "",
            "Created At": item?.createdAt || "",
            "Modified At": item?.updatedAt || "",
            "Modified by": item?.updatedBy?.firstName
              ? item?.updatedBy?.firstName + " " + item?.updatedBy?.lastName
              : "",
            Products: Array.isArray(products) ? products.map((tag) => tag?.label || "").join(",") : "",
          };
        });
        //console.log("Data transformation complete");

        // Step 3: Create Excel file
        try {
          const worksheet = XLSX.utils.json_to_sheet(tempData);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Tickets");
          //console.log("Excel workbook created");

          // Step 4: Generate blob
          try {
            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
            const blob = new Blob([excelBuffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            //console.log("Blob created successfully");

            // Step 5: Trigger download
            try {
              const url = URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.download = "ticketing_page.xlsx";
              document.body.appendChild(link);
              //console.log("Download link created, attempting to click");
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(url);
              //console.log("Download triggered successfully");
            } catch (downloadErr) {
              console.error("Download link error:", downloadErr);
              throw downloadErr;
            }
          } catch (blobErr) {
            console.error("Blob creation error:", blobErr);
            throw blobErr;
          }
        } catch (excelErr) {
          console.error("Excel creation error:", excelErr);
          throw excelErr;
        }
      } catch (transformErr) {
        console.error("Data transformation error:", transformErr);
        throw transformErr;
      }
    } catch (error) {
      // This will show the full error object with stack trace
      console.error("Full error details:", error);

      // For debugging, show error name and message
      if (error instanceof Error) {
        console.error(`Error type: ${error.name}, Message: ${error.message}`);
      } else {
        console.error("Unknown error type:", typeof error);
      }

      setIsLoadingDownload(false);
    }
    setIsLoadingDownload(false);
  };

  useEffect(() => {
    const queryTextValue =
      queryId + queryName + queryContact + queryPhone + queryLeadSource + queryProspect + queryCampaign + queryPic;
    const fieldTextValue =
      fieldId + fieldName + fieldContact + fieldPhone + fieldLeadSource + fieldProspect + fieldCampaign + fieldPic;

    setQueryText(queryTextValue);
    setFieldText(fieldTextValue);
    setQueryBusiness(queryBusiness);
    setOrderBy(orderBy);

    // Simpan status filter dan sorting saat ini di localStorage
    const currentFilter = {
      orderBy: orderBy,
      queryText: queryTextValue,
      fieldText: fieldTextValue,
      queryRating,
      queryStatus,
      queryBusiness: queryBusiness,
    };

    localStorage.setItem("currentFilter", JSON.stringify(currentFilter));
  }, [
    orderBy,
    queryId,
    queryName,
    queryContact,
    queryPhone,
    queryLeadSource,
    queryProspect,
    queryCampaign,
    queryPic,
    queryStatus,
    queryRating,
    queryBusiness,
    fieldId,
    fieldName,
    fieldContact,
    fieldPhone,
    fieldLeadSource,
    fieldProspect,
    fieldCampaign,
    fieldPic,
    fieldRating,
    fieldStatus,
  ]);
  useEffect(() => {
    // Ambil status filter dan sorting dari localStorage
    const savedFilter = JSON.parse(localStorage.getItem("currentFilter"));

    if (
      (savedFilter.queryText !== "" && savedFilter.fieldText !== "") ||
      savedFilter.queryRating !== "" ||
      savedFilter.queryStatus !== "" ||
      savedFilter.queryBusiness !== ""
    ) {
      setonSearch(true);

      refreshTicketsByQuery(
        savedFilter.queryText,
        1,
        savedFilter.fieldText,
        savedFilter.queryBusiness,
        savedFilter.orderBy,
        savedFilter.queryStatus,
        savedFilter.queryRating,
      );
    } else {
      setonSearch(false);
      refreshTickets(1);
    }
  }, [fieldText, queryText, queryRating, queryStatus, queryChannel, triggerPersistentRefresh]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClearPlus = () => {
    setShowPlus(false);
  };

  return (
    <React.Fragment>
      <Head title="Ticket - Compact"></Head>
      <Content>
        <BlockHead size="sm" className="pl-4">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Ticketing
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand mr-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="menu-alt-r"></Icon>
                </Button>
                {!roleFunctions.includes("download") || (
                  <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                    <ul className="nk-block-tools g-3">
                      {isLoadingDownload ? (
                        <Spinner></Spinner>
                      ) : (
                        <li>
                          <a
                            href="#export"
                            onClick={(ev) => {
                              ev.preventDefault();
                              handleDownload();
                            }}
                            className="btn btn-white btn-outline-light"
                          >
                            <Icon name="download-cloud"></Icon>
                            <span>Download</span>
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                )}
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <DataTable>
            <Row>
              <Col xs="5" sm="4" md="4" lg="3" className="fixed-column ">
                <DataTableBody compact>
                  <SimpleBar className="ticket-simplebar">
                    <DataTableHead>
                      <DataTableRow>
                        <div
                          className="sub-text d-flex justify-content-between align-items-center"
                          style={{ width: 150 }}
                        >
                          Ticket ID{" "}
                          <Button size="xs" id="ticketId">
                            <Icon name="sort" />
                          </Button>
                        </div>
                        <UncontrolledTooltip autohide={false} placement="top" target="ticketId">
                          <div className="tooltip-ticket-sorting">
                            <Button
                              color={orderBy === "ASC" ? "primary" : "secondary"}
                              onClick={() => onSortClicked("ticket.id", "ASC")}
                              size="xs"
                            >
                              ASC
                            </Button>
                            <Button
                              color={orderBy === "DESC" ? "primary" : "secondary"}
                              onClick={() => onSortClicked("ticket.id", "DESC")}
                              size="xs"
                            >
                              DESC
                            </Button>
                          </div>
                        </UncontrolledTooltip>
                      </DataTableRow>
                      <DataTableRow>
                        <div
                          className="sub-text d-flex justify-content-between align-items-center"
                          style={{ width: 150 }}
                        >
                          Ticket Name
                          <Button id="ticketName" size="xs">
                            <Icon name="sort" />
                          </Button>
                        </div>
                        <UncontrolledTooltip autohide={false} placement="top" target="ticketName">
                          <div className="tooltip-ticket-sorting">
                            <Button
                              color={orderBy === "ASC" ? "primary" : "secondary"}
                              onClick={() => onSortClicked("ticket.name", "ASC")}
                              size="xs"
                            >
                              ASC
                            </Button>
                            <Button
                              color={orderBy === "DESC" ? "primary" : "secondary"}
                              onClick={() => onSortClicked("ticket.name", "DESC")}
                              size="xs"
                            >
                              DESC
                            </Button>
                          </div>
                        </UncontrolledTooltip>
                      </DataTableRow>
                    </DataTableHead>
                    <DataTableHead>
                      <DataTableRow>
                        <div className="form-control-wrap mt-1" style={{ width: 150 }}>
                          {/* <div className="form-icon form-icon-right">
                            <Icon name="search"></Icon>
                          </div> */}
                          {/* <input
                            disabled={activeSearch !== "id-search" && activeSearch !== ""}
                            onChange={(e) => {
                              setQueryId("," + e.target.value);
                              setFieldId(",ticket.id");
                              if (e.target.value === "") {
                                let fieldN = fieldId;
                                setFieldContact(fieldN.replace(/ticket\\.id/g, ""));
                              }
                            }}
                            onBlur={() => setActiveSearch("")}
                            type="text"
                            className="form-control w-100"
                            id="id-search"
                          /> */}
                        </div>
                      </DataTableRow>
                      <DataTableRow>
                        <div className="form-control-wrap mt-1" style={{ width: 150 }}>
                          <div className="form-icon form-icon-right">
                            <Icon name="search"></Icon>
                          </div>
                          <input
                            disabled={activeSearch !== "name-search" && activeSearch !== ""}
                            onBlur={() => setActiveSearch("")}
                            onChange={(e) => {
                              setQueryName("," + e.target.value);
                              setFieldName(",ticket.name");
                              if (e.target.value === "") {
                                let fieldN = fieldName;
                                setFieldName(fieldN.replace(",ticket.name", ""));
                              }
                            }}
                            type="text"
                            className="form-control w-100"
                            id="name-search"
                          />
                        </div>
                      </DataTableRow>
                    </DataTableHead>
                    {/*Head*/}
                    {currentItems.map((item, idx) => {
                      return (
                        <DataTableItem key={item.id}>
                          <DataTableRow
                            noWrap
                            customStyle={nonFixedHeight.length > 0 ? { height: nonFixedHeight[idx] } : {}}
                            className="sm"
                          >
                            {item.id.substring(0, 10)}
                          </DataTableRow>
                          <DataTableRow noWrap>
                            {item?.name?.length > 20 ? item.name.substring(0, 20) + "..." : item?.name}
                          </DataTableRow>
                        </DataTableItem>
                      );
                    })}
                  </SimpleBar>
                </DataTableBody>
              </Col>
              <Col xs="5" sm="8" md="8" lg="9" className="nfixed-column">
                <DataTableBody compact>
                  <SimpleBar className="ticket-simplebar">
                    <DataTableHead>
                      <DataTableRow noWrap>
                        <div className="sub-text d-flex justify-content-between align-items-center">
                          Customer Name
                          <Button size="xs" id="contactName">
                            <Icon name="sort" />
                          </Button>
                          <UncontrolledTooltip autohide={false} placement="top" target="contactName">
                            <div className="tooltip-ticket-sorting">
                              <Button
                                color={orderBy === "ASC" ? "primary" : "secondary"}
                                onClick={() => onSortClicked("contact.name", "ASC")}
                                size="xs"
                              >
                                ASC
                              </Button>
                              <Button
                                color={orderBy === "DESC" ? "primary" : "secondary"}
                                onClick={() => onSortClicked("contact.name", "DESC")}
                                size="xs"
                              >
                                DESC
                              </Button>
                            </div>
                          </UncontrolledTooltip>
                        </div>
                      </DataTableRow>
                      <DataTableRow noWrap>
                        <div className="sub-text d-flex justify-content-between align-items-center">
                          Number Telephone
                          <Button size="xs" id="chatCustomerPhone">
                            <Icon name="sort" />
                          </Button>
                          <UncontrolledTooltip autohide={false} placement="top" target="chatCustomerPhone">
                            <div className="tooltip-ticket-sorting">
                              <Button
                                color={orderBy === "ASC" ? "primary" : "secondary"}
                                onClick={() => onSortClicked("chat.customerPhone", "ASC")}
                                size="xs"
                              >
                                ASC
                              </Button>
                              <Button
                                color={orderBy === "DESC" ? "primary" : "secondary"}
                                onClick={() => onSortClicked("chat.customerPhone", "DESC")}
                                size="xs"
                              >
                                DESC
                              </Button>
                            </div>
                          </UncontrolledTooltip>
                        </div>
                      </DataTableRow>
                      <DataTableRow noWrap>
                        <div
                          style={{ width: "150px" }}
                          className="sub-text d-flex justify-content-between align-items-center"
                        >
                          Business
                        </div>
                      </DataTableRow>
                      <DataTableRow noWrap>
                        <div
                          className="sub-text d-flex justify-content-between align-items-center"
                          style={{ width: 200 }}
                        >
                          Lead Source
                        </div>
                      </DataTableRow>
                      <DataTableRow noWrap>
                        <div
                          className="sub-text d-flex justify-content-between align-items-center"
                          style={{ width: 200 }}
                        >
                          Prospect
                        </div>
                      </DataTableRow>
                      <DataTableRow noWrap>
                        <div
                          className="sub-text d-flex justify-content-between align-items-center"
                          style={{ width: 180 }}
                        >
                          Campaign
                        </div>
                      </DataTableRow>
                      <DataTableRow noWrap>
                        <div
                          className="sub-text d-flex justify-content-between align-items-center"
                          style={{ width: 150 }}
                        >
                          Channel
                        </div>
                      </DataTableRow>
                      <DataTableRow noWrap>
                        <div
                          className="sub-text d-flex justify-content-between align-items-center"
                          style={{ width: 150 }}
                        >
                          Status
                        </div>
                      </DataTableRow>
                      <DataTableRow noWrap>
                        <div
                          className="sub-text d-flex justify-content-between align-items-center"
                          style={{ width: 200 }}
                        >
                          PIC
                        </div>
                      </DataTableRow>
                      <DataTableRow noWrap>
                        <div
                          className="sub-text d-flex justify-content-between align-items-center"
                          style={{ width: 80 }}
                        >
                          Rating
                        </div>
                      </DataTableRow>
                      <DataTableRow noWrap>
                        <div
                          className="sub-text d-flex justify-content-between align-items-center"
                          style={{ width: 80 }}
                        >
                          Rate At
                        </div>
                      </DataTableRow>
                      <DataTableRow noWrap>
                        <div className="sub-text d-flex justify-content-between align-items-center">Action</div>
                      </DataTableRow>
                      <DataTableRow noWrap>
                        <div className="sub-text d-flex justify-content-between align-items-center">
                          Created at
                          <Button size="xs" id="createdAt">
                            <Icon name="sort" />
                          </Button>
                        </div>
                        <UncontrolledTooltip autohide={false} placement="top" target="createdAt">
                          <div className="tooltip-ticket-sorting">
                            <Button
                              color={orderBy === "ASC" ? "primary" : "secondary"}
                              onClick={() => onSortClicked("ticket.createdAt", "ASC")}
                              size="xs"
                            >
                              ASC
                            </Button>
                            <Button
                              color={orderBy === "DESC" ? "primary" : "secondary"}
                              onClick={() => onSortClicked("ticket.createdAt", "DESC")}
                              size="xs"
                            >
                              DESC
                            </Button>
                          </div>
                        </UncontrolledTooltip>
                      </DataTableRow>
                      <DataTableRow noWrap>
                        <div className="sub-text d-flex justify-content-between align-items-center">
                          Modified at
                          <Button size="xs" id="updatedAt">
                            <Icon name="sort" />
                          </Button>
                        </div>
                        <UncontrolledTooltip autohide={false} placement="top" target="updatedAt">
                          <div className="tooltip-ticket-sorting">
                            <Button
                              color={orderBy === "ASC" ? "primary" : "secondary"}
                              onClick={() => onSortClicked("ticket.updatedAt", "ASC")}
                              size="xs"
                            >
                              ASC
                            </Button>
                            <Button
                              color={orderBy === "DESC" ? "primary" : "secondary"}
                              onClick={() => onSortClicked("ticket.updatedAt", "DESC")}
                              size="xs"
                            >
                              DESC
                            </Button>
                          </div>
                        </UncontrolledTooltip>
                      </DataTableRow>
                      <DataTableRow noWrap>
                        <div className="sub-text d-flex justify-content-between align-items-center">Modified by</div>
                      </DataTableRow>
                    </DataTableHead>
                    {/*Head*/}
                    <DataTableHead>
                      <DataTableRow>
                        <div className="form-control-wrap mt-1">
                          <div className="form-icon form-icon-right">
                            <Icon name="search"></Icon>
                          </div>
                          <input
                            disabled={activeSearch !== "customer-search" && activeSearch !== ""}
                            id="customer-search"
                            type="text"
                            className="form-control w-100"
                            onChange={(e) => {
                              setQueryContact("," + e.target.value);
                              setFieldContact(",contact.name");
                              // setQueryPhone("," + e.target.value);
                              // setFieldPhone(",chat.customerPhone");
                              if (e.target.value === "") {
                                setFieldContact("");
                              }
                            }}
                            onBlur={() => setActiveSearch("")}
                          />
                        </div>
                      </DataTableRow>
                      <DataTableRow>
                        <div className="form-control-wrap mt-1">
                          <div className="form-icon form-icon-right">
                            <Icon name="search"></Icon>
                          </div>
                          <input
                            type="text"
                            className="form-control w-100"
                            disabled={activeSearch !== "customer-phone-search" && activeSearch !== ""}
                            onChange={(e) => {
                              setQueryPhone("," + e.target.value);
                              setFieldPhone(",chat.customerPhone");
                              if (e.target.value === "") {
                                // let fieldN = fieldPhone;
                                // setFieldPhone(fieldN.replace(/chat\\.customerPhone/g, ""));
                                setFieldPhone("");
                              }
                            }}
                            onBlur={() => setActiveSearch("")}
                            id="customer-phone-search"
                          />
                          {queryPhone && showPlus && (
                            <span
                              style={{
                                position: "absolute",
                                left: "5px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                              }}
                              onClick={handleClearPlus}
                            >
                              +
                            </span>
                          )}
                        </div>
                      </DataTableRow>
                      <DataTableRow>
                        <RSelect
                          onBlur={() => setOnSearchText("")}
                          onChange={onSelectChangeBusiness}
                          options={businessOption}
                        />
                      </DataTableRow>
                      <DataTableRow>
                        <RSelect
                          onChange={onSelectChangeLeadSource}
                          components={(e) => CampaignBadge(e.label)}
                          options={leadSourceOption}
                        />
                      </DataTableRow>
                      <DataTableRow>
                        <RSelect
                          onChange={onSelectProspect}
                          components={(e) => CampaignBadge(e.label)}
                          options={prospectOption}
                        />
                      </DataTableRow>
                      <DataTableRow>
                        <RSelect
                          onChange={onSelectChangeCampaign}
                          options={campaignOption}
                          onMenuScrollToBottom={handleCampaignSelectScroll}
                        />
                      </DataTableRow>
                      <DataTableRow>
                        <RSelect onChange={onSelectChannel} options={channelOption} />
                      </DataTableRow>
                      <DataTableRow>
                        <RSelect onChange={onSelectStatus} options={statusOption} />
                      </DataTableRow>
                      <DataTableRow>
                        <div className="form-control-wrap mt-1">
                          <div className="form-icon form-icon-right">
                            <Icon name="search"></Icon>
                          </div>
                          <input
                            type="text"
                            className="form-control w-100"
                            disabled={activeSearch !== "pic-search" && activeSearch !== ""}
                            onChange={(e) => {
                              setQueryPic("," + e.target.value);
                              setFieldPic(",user.firstName");
                              if (e.target.value === "") {
                                let fieldN = fieldPic;
                                setFieldPic(fieldN.replace(/user\\.firstName/g, ""));
                              }
                            }}
                            onBlur={() => setActiveSearch("")}
                            id="pic-search"
                          />
                        </div>
                      </DataTableRow>
                      <DataTableRow noWrap>
                        <RSelect onChange={onSelectRating} options={ratingOption} />
                      </DataTableRow>
                      <DataTableRow>
                        {/* <div className="form-control-wrap mt-1">
                          <div className="form-icon form-icon-right">
                            <Icon name="search"></Icon>
                          </div>
                          <input type="text" className="form-control w-100" id="default-04" />
                        </div> */}
                      </DataTableRow>
                      <DataTableRow>
                        {/* <div className="form-control-wrap mt-1">
                          <div className="form-icon form-icon-right">
                            <Icon name="search"></Icon>
                          </div>
                          <input type="text" className="form-control w-100" id="default-04" />
                        </div> */}
                      </DataTableRow>
                      <DataTableRow>
                        {/* <div className="form-control-wrap mt-1">
                          <div className="form-icon form-icon-right">
                            <Icon name="search"></Icon>
                          </div>
                          <input type="text" className="form-control w-100" id="default-04" />
                        </div> */}
                      </DataTableRow>
                      <DataTableRow>
                        {/* <div className="form-control-wrap mt-1">
                          <div className="form-icon form-icon-right">
                            <Icon name="search"></Icon>
                          </div>
                          <input type="text" className="form-control w-100" id="default-04" />
                        </div> */}
                      </DataTableRow>
                    </DataTableHead>
                    {currentItems.map((item, idx) => {
                      return (
                        <DataTableItem key={item.id}>
                          <DataTableRow size="md" ref={addToRefs}>
                            {/* {item.chat?.contact.isSaved ? item.chat?.contact.name : `+${item.chat?.customerPhone}`} */}
                            {item?.chat?.name ?? item?.chat?.customerPhone ?? item?.name}
                          </DataTableRow>
                          <DataTableRow>{utilNumberPhoneConvention(item.chat?.customerPhone)}</DataTableRow>
                          <DataTableRow>
                            <span
                              className="badge rounded-pill text-bg-primary"
                              style={{
                                background: item?.department?.color ? item.department.color : "#fffff",
                                borderColor: item?.department?.color ? item.department.color : "#fffff",
                                color: getTextColor(item.department?.color ? item.department.color : "#fffff"),
                              }}
                            >
                              {item?.department?.name}
                            </span>
                          </DataTableRow>
                          <DataTableRow>
                            <div
                              className="badge rounded-pill text-bg-primary"
                              style={{
                                background: `${
                                  item?.tags?.find((tag) => tag?.tagCategory?.name === "Lead Source")?.color ?? "black"
                                }`,
                                color: "white",
                              }}
                            >
                              {item?.tags?.find((tag) => tag?.tagCategory?.name === "Lead Source")?.name ?? ""}
                            </div>
                          </DataTableRow>
                          <DataTableRow>
                            <div
                              className="badge rounded-pill text-bg-primary"
                              style={{
                                background: `${
                                  item?.tags?.find((tag) => tag?.tagCategory?.name === "Status Prospect")?.color ??
                                  "black"
                                }`,
                                color: "white",
                              }}
                            >
                              {item?.tags?.find((tag) => tag?.tagCategory?.name === "Status Prospect")?.name ?? ""}
                            </div>
                          </DataTableRow>
                          <DataTableRow>
                            {CampaignBadge(
                              item?.campaign?.shortUrl
                                ?.replace("https://astronacci.org/", "")
                                .replace("https://url.ismartglobal.id/", "") || "-",
                              item,
                            )}
                          </DataTableRow>
                          <DataTableRow>{CampaignBadge(CHANNEL_LABEL[item.channel] ?? "WhatsApp")}</DataTableRow>
                          <DataTableRow>
                            {item.user?.firstName === "Chatbot" ? (
                              "Chatbot"
                            ) : (
                              <Badge
                                color={`outline-${
                                  item?.status === "RESOLVED"
                                    ? "success"
                                    : item?.status === "OPENED"
                                      ? "primary"
                                      : item?.status === "PENDING"
                                        ? "warning"
                                        : "danger"
                                }`}
                                pill
                              >
                                {item?.status === null ? "UNOPENED" : item.status}
                              </Badge>
                            )}
                          </DataTableRow>
                          <DataTableRow className="font-italic">
                            {item.user?.firstName ? item.user?.firstName + " " + item.user?.lastName : "-"}
                          </DataTableRow>
                          <DataTableRow className="font-italic">{item?.rating ? item?.rating : "0"}</DataTableRow>
                          <DataTableRow className="font-italic">
                            {item?.ratedAt ? moment(item?.ratedAt).format("MMM DD, YYYY, HH:mm") : "-"}
                          </DataTableRow>
                          <DataTableRow>
                            <ul className="table-action">
                              <li className="nk-tb-action">
                                <Link
                                  id={"detail" + item.id}
                                  to={{
                                    pathname: process.env.PUBLIC_URL + "/ticket/detail",
                                    state: {
                                      ticket: item,
                                      edit: false,
                                      picOptions: [],
                                    },
                                  }}
                                  className="btn btn-trigger btn-icon"
                                >
                                  <Icon name="eye-fill" />
                                </Link>
                                <UncontrolledTooltip autohide={false} placement="top" target={"detail" + item.id}>
                                  Detail
                                </UncontrolledTooltip>
                              </li>
                              {!roleFunctions.includes("update") || (
                                <li className="nk-tb-action">
                                  <Link
                                    id={"edit" + item.id}
                                    to={{
                                      pathname: process.env.PUBLIC_URL + "/ticket/detail",
                                      state: {
                                        ticket: item,
                                        edit: true,
                                        picOptions: [],
                                      },
                                    }}
                                    className="btn btn-trigger btn-icon"
                                  >
                                    <Icon name="edit-alt-fill" />
                                  </Link>
                                  <UncontrolledTooltip autohide={false} placement="top" target={"edit" + item.id}>
                                    Edit
                                  </UncontrolledTooltip>
                                </li>
                              )}
                              {/* {!roleFunctions.includes("delete") || (
                                <li
                                  className="nk-tb-action"
                                  onClick={() => {
                                    handleDelete(item.id);
                                  }}
                                >
                                  <TooltipComponent
                                    tag="a"
                                    containerClassName="btn btn-trigger btn-icon"
                                    id={"delete" + item.id}
                                    icon="trash-fill"
                                    direction="top"
                                    text="Hapus"
                                  />
                                </li>
                              )} */}
                            </ul>
                          </DataTableRow>
                          <DataTableRow noWrap>{moment(item.createdAt).format("MMM DD, YYYY, HH:mm")}</DataTableRow>
                          <DataTableRow noWrap>{moment(item.updatedAt).format("MMM DD, YYYY, HH:mm")}</DataTableRow>
                          <DataTableRow noWrap>
                            {item.updatedBy ? item.updatedBy?.firstName + " " + item.updatedBy?.lastName : ""}
                          </DataTableRow>
                        </DataTableItem>
                      );
                    })}
                  </SimpleBar>
                </DataTableBody>
              </Col>
            </Row>
            <div className="card-inner">
              {currentItems.length > 0 ? (
                <PaginationComponent
                  itemPerPage={metaData?.take}
                  totalItems={metaData?.itemCount}
                  paginate={paginate}
                  currentPage={metaData?.page}
                />
              ) : (
                <div className="text-center">
                  <span className="text-silent">No data found</span>
                </div>
              )}
            </div>
            <div className="pt-4 mb-2 pl-4 border-top">
              <BlockTitle tag="h3" page>
                Status Summary
              </BlockTitle>
            </div>
            <div className="d-flex text-center mb-5">
              <div className="border-right px-5 py-4 ">
                <BlockTitle tag="h2" className="">
                  {summaryData.unopened}
                </BlockTitle>
                <div
                  style={{ fontSize: "18px" }}
                  className="d-flex justify-content-center align-items-center mt-2 text-danger"
                >
                  <Icon name="cross" />
                  <p className="ml-1"> Unopened</p>
                </div>
              </div>
              <div className="border-right px-5 py-4 ">
                <BlockTitle tag="h2" className="">
                  {summaryData.opened}
                </BlockTitle>
                <div
                  style={{ fontSize: "18px" }}
                  className="d-flex justify-content-center align-items-center mt-2 text-primary"
                >
                  <Icon name="clock" />
                  <p className="ml-1"> Opened</p>
                </div>
              </div>
              <div className="px-5 py-4  border-right " style={{ fontSize: "18px" }}>
                <BlockTitle tag="h2" className="">
                  {summaryData.pending}
                </BlockTitle>
                <div className="d-flex justify-content-center align-items-center mt-2 text-warning">
                  <Icon name="loader" />
                  <p className="ml-1"> Pending</p>
                </div>
              </div>
              <div className="px-5 py-4  " style={{ fontSize: "18px" }}>
                <BlockTitle tag="h2" className="">
                  {summaryData.resolved}
                </BlockTitle>
                <div className="d-flex justify-content-center align-items-center mt-2 text-success">
                  <Icon name="check" />
                  <p className="ml-1"> Resolved</p>
                </div>
              </div>
            </div>
          </DataTable>
        </Block>
      </Content>
    </React.Fragment>
  );
};
export default Ticket;
